import { api } from './api.js';

/**
 * Starts a Stripe Checkout Session and redirects the browser to the
 * hosted payment page. Requires the user to be authenticated.
 */
export async function startCheckout(plan) {
  const data = await api('/api/payments/checkout', {
    method: 'POST',
    body: JSON.stringify({ plan }),
  });
  if (data?.url) {
    window.location.href = data.url;
    return;
  }
  throw new Error('checkout_no_url');
}
